import axios from '@/utilities/axios-global'

export function GET_REVIEWVALIDATIONS(context, payload) {
  return new Promise((resolve, reject) => {
    if (context.state.reviewValidations.length > 0) {
      resolve()
      return
    }
    axios.get(context.rootState.user.baseApiUrl + `/reviewrequests/validations`).then((response) => {
      context.commit('SET_REVIEWVALIDATIONS', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_REVIEW_TYPES(context, payload) {
  return new Promise((resolve, reject) => {
    if (context.state.reviewTypes.length > 0) {
      resolve()
      return
    }

    axios.get(context.rootState.user.baseApiUrl + `/reviewrequests/request-types`).then((response) => {
      context.commit('SET_REVIEWTYPES', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_REVIEW_SCHEDULE_REQUEST(context, id) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + '/reviewrequests/' + id).then(response => {
      context.commit('SET_REVIEW_SCHEDULE_REQUEST', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function POST_REVIEW_SCHEDULE_REQUEST(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/reviewrequests`, payload).then(response => {
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function PUT_REVIEW_SCHEDULE_REQUEST(context, payload) {
  return new Promise((resolve, reject) => {
    axios.put(context.rootState.user.baseApiUrl + `/reviewrequests/${payload.requestId}`, payload.reviewRequest).then(response => {
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function PUT_TOGGLE_PRO_SELECTED_BY(context, payload) {
  return new Promise((resolve, reject) => {
    axios.put(context.rootState.user.baseApiUrl + `/reviewrequests/toggleproselectedby/${payload.requestId}`, payload.reviewRequest).then(response => {
      context.commit('SET_PRORECORDS_RECORDS', [])
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function PUT_REVIEW_SCHEDULE_REQUEST_RECORDS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.put(context.rootState.user.baseApiUrl + `/reviewrequests/${payload.requestId}/records/${payload.patientType}`, payload.records).then(response => {
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function PUT_REVIEW_SCHEDULE_REQUEST_PRO_RECORDS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.put(context.rootState.user.baseApiUrl + `/reviewrequests/${payload.requestId}/prorecords/`, payload.records).then(response => {
      context.commit('SET_PRORECORDS_RECORDS', response.data.records)
      resolve(response.data)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function DELETE_REVIEW_SCHEDULE_REQUEST_RECORDS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.delete(context.rootState.user.baseApiUrl + `/reviewrequests/${payload.requestId}/clearrecords/${payload.patientType}`).then(response => {
      resolve(response)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function DELETE_REVIEW_SCHEDULE_REQUEST_PRO_RECORDS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.delete(context.rootState.user.baseApiUrl + `/reviewrequests/${payload.requestId}/clearprorecords`).then(response => {
      resolve(response)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function PUT_REVIEW_SCHEDULE_REQUEST_AMBULATORY_RECORDS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.put(context.rootState.user.baseApiUrl + `/reviewrequests/${payload.requestId}/ambulatoryrecords/`, payload.records).then(response => {
      context.commit('SET_AMBULATORYRECORDS_PAYLOAD', response.data)
      resolve(response.data)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function DELETE_REVIEW_SCHEDULE_REQUEST_AMBULATORY_RECORDS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.delete(context.rootState.user.baseApiUrl + `/reviewrequests/${payload.requestId}/clearambulatoryrecords`).then(response => {
      context.commit('SET_AMBULATORYRECORDS_CLEARED')
      resolve(response)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function CHECK_REVIEW_EXISTS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/reviewrequests/reviewexists`, payload)
      .then(response => {
        resolve(response)
      }, error => {
        console.log(error)
        reject(error)
      })
  })
}

export default {
  PUT_TOGGLE_PRO_SELECTED_BY,
  GET_REVIEWVALIDATIONS,
  POST_REVIEW_SCHEDULE_REQUEST,
  GET_REVIEW_SCHEDULE_REQUEST,
  PUT_REVIEW_SCHEDULE_REQUEST,
  PUT_REVIEW_SCHEDULE_REQUEST_RECORDS,
  PUT_REVIEW_SCHEDULE_REQUEST_PRO_RECORDS,
  PUT_REVIEW_SCHEDULE_REQUEST_AMBULATORY_RECORDS,
  DELETE_REVIEW_SCHEDULE_REQUEST_RECORDS,
  DELETE_REVIEW_SCHEDULE_REQUEST_PRO_RECORDS,
  DELETE_REVIEW_SCHEDULE_REQUEST_AMBULATORY_RECORDS,
  CHECK_REVIEW_EXISTS,
  GET_REVIEW_TYPES
}
